
<div class="container" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <div class="row">
    <div class="col">
      <p>Optional: download, edit, and re-upload a spreadsheet containing additional asset details.</p>
    </div>
  </div>
  <div class="row alert-container-block">
    <error [error]="error"></error>
  </div>
  <div class="row alert-container-block" *ngIf="siteDifferences.length">
    <div class="alert alert-warning" style="min-width: 500px;"><span>ERROR: Sites differ between TMC and {{labelFrom}}</span><span class="float-right">
        <button class="float-right btn btn-outline-secondary" type="button" (click)="viewDifferingSites()">View Differences</button></span></div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filterAssets.length" (onChange)="onListControlsChange($event)">
        <div class="dropdown" [hidden]="deployment.installed">
          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" [downloadFile]="'/api/DeploymentWorkflow/export-assets/' + deploymentId"><span class="oi oi-cloud-download"></span> Export Assets</a><a class="dropdown-item" [uploadFileTo]="'/api/DeploymentWorkflow/import-assets/' + deploymentId" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Import Assets'" (closed)="loadData()" [ngClass]="{'disabled': deployment.installed }"><span class="oi oi-cloud-upload"></span> Upload Assets</a><a class="dropdown-item" [downloadFile]="'/api/DeploymentWorkflow/export-deployed-devices-report'" [params]="{deploymentId: workflowTargetInfo.targetId}"><span class="oi oi-cloud-download"></span> Create Deployed Asset Report</a></div>
        </div>
      </list-controls>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [(ngModel)]="hideCompletedAssets" (change)="onListControlsChange($event)" autoLinkToLabel>
        <label class="form-check-label">Hide assets that exist in {{labelFrom}}</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [(ngModel)]="hideDataFullAssets" (change)="onListControlsChange($event)" autoLinkToLabel>
        <label class="form-check-label">Show only items that need further configuration to allow export to {{labelFrom}}</label>
      </div>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th>SKU</th>
            <th>Model</th>
            <th>Device Key</th>
            <th>Serial Number</th>
            <th>Asset Tag</th>
            <th>Building</th>
            <th>Floor</th>
            <th>Map ID</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let asset of displayAssets; let idx = index;">
            <td>{{ asset.productNumber }}</td>
            <td><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><span>{{ asset.model }}</span></td>
            <td *ngIf="asset.type === 'asset'">{{ asset.deviceKey }}</td>
            <td class="text-red" *ngIf="asset.type === 'asset removal'">Removal</td>
            <td>{{ asset.serialNumber }}</td>
            <td>{{ asset.assetTag }}</td>
            <td>{{ asset.building }}</td>
            <td>{{ asset.floor }}</td>
            <td>{{ asset.floorMapId }}</td>
            <td>
              <status-indicator [states]="assetStateList" [key]="asset.statusKey" [detail]="asset.statusDetail"></status-indicator>
            </td>
            <td>
              <div class="btn-group">
                <button class="btn btn-outline-primary btn-sm" (click)="edit(asset)" [disabled]="asset.installed || asset.ordered">Edit</button>
              </div>
            </td>
          </tr>
          <tr *ngIf="displayAssets.length === 0">
            <td colspan="8">
              <p class="text-center empty-table-message">There are no matching assets to display</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>